/**
 * Created by miguelsl on 30/12/16.
 */


class ProductDetailInformationViewController extends MUIViewController implements ProductRecommendedCellDelegate
{
    static newInstance() : ProductDetailInformationViewController { 
        let vc = new ProductDetailInformationViewController("product-information-view");
        vc.initWithResource("layout/products/ProductInformationView.html");
        return vc;
    }

    private shortdescriptionTextField:MUITextField = null;
    private languageButton:MUIButton = null;

    private detaildescriptionTextArea:MUITextArea = null;
    private componentsdescriptionTextArea:MUITextArea = null;
    private tagView:TagView = null;
    private stockTagView:TagView = null;
    private ledgerAccountDropdown:MUIButton = null;
    private accountNumberTextField:MUITextField = null;

    private salesAccountDropdown:MUIButton = null;
    private purchaseAccountDropdown:MUIButton = null;
    
    private extraimagesCollectionView:MUICollectionView = null;

    private recommendedProductsTableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.shortdescriptionTextField = MUIOutlet(this, 'pinv_b1_short_description_textfield', 'MUITextField');
        this.shortdescriptionTextField.setOnChangeText(this, function (textfield, value){
            this._product.info = value;
            MIONotificationCenter.defaultCenter().postNotification("ProductChangeValue", value);
        });

        this.languageButton = MUIOutlet(this, "language-btn", "MUIButton");
        this.languageButton.setAction(this, function(){
            let vc = ProductLanguageViewController.newInstance();
            vc.modalSize = new MIOSize(800, 400);
            vc.setItem(this._product, "info", true);
            
            this.presentViewController( vc, true );
        });


        this.detaildescriptionTextArea = MUIOutlet(this, 'pinv_b1_detail_description_textarea', 'MUITextArea');
        this.detaildescriptionTextArea.setOnChangeText(this, function (textarea, value){
            this._product.detailedInfo = value;
            MIONotificationCenter.defaultCenter().postNotification("ProductChangeValue", value);
        });

        this.componentsdescriptionTextArea = MUIOutlet(this, 'pinv_b1_components_description_textarea', 'MUITextArea');
        this.componentsdescriptionTextArea.setOnChangeText(this, function (textarea, value){
            this._product.componentsInfo = value;
            MIONotificationCenter.defaultCenter().postNotification("ProductChangeValue", value);
        })

       this.tagView = MUIOutlet(this, 'tag-view', 'TagView');
       this.tagView.delegate = this;

       this.stockTagView = MUIOutlet(this, 'stock-tag-view', 'TagView');
       this.stockTagView.delegate = this;

        this.ledgerAccountDropdown = MUIOutlet(this, "ledger-account-dd", "MUIButton");
        this.ledgerAccountDropdown.setAction(this, function(){
            (AppHelper.sharedInstance() as any).showSelectLedgerAccountViewControllerFromView(this.ledgerAccountDropdown, this._product.ledgerAccount, this, this.updateLedgerAccount);
        });

        this.accountNumberTextField = MUIOutlet(this, "account-number-tf", "MUITextField");
        this.accountNumberTextField.setOnChangeText(this, function(this:ProductDetailInformationViewController, control:MUITextField, value:string){
            (this._product as any).accountNumber = value.length > 0 ? value : null;
        });

        this.salesAccountDropdown = MUIOutlet(this, "sales-ledger-account-dd", "MUIButton");
        this.salesAccountDropdown.setAction(this, function(this:ProductDetailInformationViewController){            
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.salesAccountDropdown, this._product.salesLedgerAccount, null, false, this._product.name, this, this.updateSalesLedgerAccount);
        });

        this.purchaseAccountDropdown = MUIOutlet(this, "purchase-ledger-account-dd", "MUIButton");
        this.purchaseAccountDropdown.setAction(this, function(this:ProductDetailInformationViewController){
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.purchaseAccountDropdown, this._product.purchaseLedgerAccount, null, false, this._product.name, this, this.updatePurchaseLedgerAccount);
        });

        this.recommendedProductsTableView = MUIOutlet(this, "table-view", "UITableView");
        this.recommendedProductsTableView.dataSource = this;
        this.recommendedProductsTableView.delegate = this;
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private productTags:string[] = null;
    private productStockTags:string[] = null;
    private _product:Product = null;
    set product(value){
        this._product = value;
        this.productTags = ProductDetailInformationViewController.tagNames(this._product.tags);
        this.productStockTags = ProductDetailInformationViewController.tagNames(this._product.stockTags);
        this.updateUI();
    }

    private static tagNames(value:string):string[] {
        return (value == null || value.length == 0) ? [] : value.split(',');
    }

    private updateUI(){
        if (this._product == null) return;
        if (this.viewIsLoaded == false) return;

        this.shortdescriptionTextField.text = this._product.info ;
        this.detaildescriptionTextArea.text = this._product.detailedInfo;
        this.componentsdescriptionTextArea.text = this._product.componentsInfo;
        // this.ledgerAccountDropdown.title = this._product.ledger;
        // this.accountNumberTextField.text = this._product.accountNumber;
        this.salesAccountDropdown.title = this._product.salesLedgerAccountName;
        this.purchaseAccountDropdown.title = this._product.purchaseLedgerAccountName;

        let predicate = MIOPredicate.predicateWithFormat('type = ' + TagType.ProductOrMenu + " and deletedAt = null");
        DBHelper.queryObjectsWithCompletion("Tag", null, predicate, [], this, function(this:ProductDetailInformationViewController, objects:Tag[]){
            this.reloadTags(this.tagView, objects, this.productTags);
        });

        let stockPredicate = MIOPredicate.predicateWithFormat('type = ' + TagType.StockCategory + " and deletedAt = null");
        DBHelper.queryObjectsWithCompletion("Tag", null, stockPredicate, [], this, function(this:ProductDetailInformationViewController, objects:Tag[]){
            this.reloadTags(this.stockTagView, objects, this.productStockTags);
        });

        this.recommendedProductsTableView.reloadData();
    }

    private reloadTags(tagView:TagView, tags:Tag[], selectedNames:string[]){
        tagView.removeAll();
        let sorted_tags = _MIOSortDescriptorSortObjects(tags, [MIOSortDescriptor.sortDescriptorWithKey("name", true)]);
        for (let index = 0; index < sorted_tags.length; index++){
            let tag = sorted_tags[index] as Tag;
            tagView.addTag(tag.name);
            if (selectedNames.containsObject(tag.name)) {
                tagView.selectTagAtIndex(index);
            }
        }
    }

    didSelectTagAtIndex(index:number, name:string, tagView:TagView){
        if (tagView == this.stockTagView) {
            ProductDetailInformationViewController.toggleTag(this.productStockTags, name);
            this._product.stockTags = ProductDetailInformationViewController.tagsString(this.productStockTags);
        }
        else {
            ProductDetailInformationViewController.toggleTag(this.productTags, name);
            this._product.tags = ProductDetailInformationViewController.tagsString(this.productTags);
        }
    }

    private static toggleTag(names:string[], name:string){
        let i = names.indexOfObject(name);
        if (i < 0) names.addObject(name);
        else names.removeObject(name);
    }

    private static tagsString(names:string[]):string {
        let array = [];
        for (let c of names) {
            if (c == null || c.length == 0) continue;
            array.push(c);
        }
        return array.length > 0 ? array.join(',') : null;
    }

    private updateLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        // this._product.ledgerAccount = account;
        // this._product.ledgerAccountName = account?.description;
        // this.ledgerAccountDropdown.title = account?.description;
    }

    private updateSalesLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        this._product.salesLedgerAccount = account;
        this._product.salesLedgerAccountName = account?.description;
        this.salesAccountDropdown.title = account?.description;
    }

    private updatePurchaseLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        this._product.purchaseLedgerAccount = account;
        this._product.purchaseLedgerAccountName = account?.description;
        this.purchaseAccountDropdown.title = account?.description;
    }

    numberOfSections(tableView:UITableView) {
        return 2;
    }

    numberOfRowsInSection(tableView:UITableView, section:number) {
        switch (section) {
            case 0: return this._product.recommendedProducts.length;
            case 1: return 1;
        }
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        if (indexPath.section == 0) {
            let cell = tableView.dequeueReusableCellWithIdentifier("LabelCell") as ProductRecommendedCell;
            let item = this._product.recommendedProducts.objectAtIndex(indexPath.row) as Product;
            cell.item = item;
            return cell;
        }
        else if (indexPath.section == 1 && indexPath.row == 0) { 
            let cell = tableView.dequeueReusableCellWithIdentifier("AddCell") as ProductRecommendedCell;
            cell.delegate = this;
            return cell;
        }
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {   
        if (indexPath.section == 1) return UITableViewCellEditingStyle.Insert;
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            let item = this._product.recommendedProducts.objectAtIndex(indexPath.row) as Product;
            this._product.removeRecommendedProductsObject(item);
            DBHelper.saveMainContext();
            this.recommendedProductsTableView.reloadData();
        }
    } 

    recommendedProductDidSelect(cell:ProductRecommendedCell, product:Product){
        this._product.addRecommendedProductsObject(product);
        DBHelper.saveMainContext();
        this.recommendedProductsTableView.reloadData();
    }
    
}